{
  "mmbRefundForm": {
    "recLocGenericError": "Varauksesi hakemisessa tapahtui virhe. Ole hyvä ja yritä uudelleen.",
    "tryRefundFormError": "Tätä varausta ei voida peruuttaa tämän työkalun kautta. Käytä alla olevaa lomaketta takaisinmaksun hakemiseen."
  },
  "productSelection": {
    "tierPrice": {
      "nextProduct": {
        "ABCBAG": "Seuraava laukku"
      },
      "addProduct": {
        "ABCBAG": "Lisää hintaan"
      }
    }
  }
}
